import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const HeadingContainer = styled.div`
  margin-bottom: 48px;
  text-align: center;
`;

const Title = styled(motion.h2)`
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 36px;
  color: #FFFFFF;
  margin-bottom: 16px;
  position: relative;
  display: inline-block;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background-color: #2196F3; /* Electric blue */
    border-radius: 2px;
  }
  
  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

const Subtitle = styled(motion.p)`
  font-family: 'Roboto', sans-serif;
  font-size: 18px;
  line-height: 1.6;
  color: #E0E0E0;
  max-width: 800px;
  margin: 24px auto 0;
  
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const SectionHeading = ({ title, subtitle }) => {
  return (
    <HeadingContainer>
      <Title
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        {title}
      </Title>
      
      {subtitle && (
        <Subtitle
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          {subtitle}
        </Subtitle>
      )}
    </HeadingContainer>
  );
};

export default SectionHeading;
